module.exports = __webpack_public_path__ + "img/call-center.2e960c83.png";